// @core/api/endpoints/document/preview_document_number.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PreviewDocumentNumberRequest,
  PreviewDocumentNumberResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Preview next number
 * Previews the next document number that would be generated by this scheme, without advancing the counter.
 */
export async function PreviewDocumentNumber(
  scheme_id: string,
  data: PreviewDocumentNumberRequest,
  options?: RequestOptions
): Promise<PreviewDocumentNumberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id/preview`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.post<PreviewDocumentNumberResponse>(requestPath, data, requestOptions);
}
